// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"5652e920","168":"f7e468e2","216":"74e87c94","332":"1c5fc28e","717":"1ba4aa06"}[chunkId] + ".chunk.js";
};